import React from 'react';
import { Linking, Platform, TouchableOpacity } from 'react-native';
import PropTypes from 'prop-types';

import { AppText } from './AppText';

/**
 * Links children to a web URL. Renders an anchor tag (<a>) on web with a TouchableOpacity fallback for native.
 */
export default function ExternalLink(props) {
  // Use an <a> on web for keyboard support, see
  // https://necolas.github.io/react-native-web/docs/accessibility/#accessibility-patterns
  if (Platform.OS === 'web') {
    return (
      <AppText href={props.to} hrefAttrs={props.hrefAttrs}>
        {props.children}
      </AppText>
    );
  }

  return (
    <TouchableOpacity role="link" onPress={() => Linking.openURL(props.to)}>
      {props.children}
    </TouchableOpacity>
  );
}

ExternalLink.propTypes = {
  children: PropTypes.node.isRequired,
  to: PropTypes.string.isRequired,
  hrefAttrs: PropTypes.shape({
    target: PropTypes.string,
  }),
};
